import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TurnstileComponent} from './turnstile.component';

@NgModule({
  declarations: [TurnstileComponent],
  imports: [CommonModule],
  exports: [TurnstileComponent],
})
export class TurnstileModule {}
